import React from "react";
import Policy from "../components/PolicyGlobal/index";

const PolicyPage = () => {
    return (
        <>
            <Policy />
        </>
    );
};

export default PolicyPage;
